import {get, find, values} from 'lodash'
import {ready} from '../lib/addiesaas'
import $ from 'jquery'

const listerers = () => {
  const EventBus = window.VueEventBus
  const DataFilter = window.VueDataFilter
  const b1g1 = 'buy1get1free'
  const b1g1ProductId = get(window.addiesaas, `midwaysports.${b1g1}.product_id`)
  const b1g1Code = get(window.addiesaas, `midwaysports.${b1g1}.coupon_code`)

  if (EventBus) {
    EventBus.$on('user.profile.view-edit.editor.mounted', function () {
      $('.rocket-effect-container .re-profile').addClass('edit-mode')
    })
    EventBus.$on('user.profile.view-edit.editor.unmounted', function () {
      $('.rocket-effect-container .re-profile').removeClass('edit-mode')
    })

    // remove b1g1free discount coupon on removal of b1g1free cart item
    // EventBus.$on('cart-item-before-delete-buy1get1free', function ({item}) {
    EventBus.$on('cart.item.before.remove', function (item) {
      if(item.type === b1g1) {
        const cartx = 'Shop/Orders/Cart/'
        const productId = get(item, 'payload.product_id')
        const store = get(window.addiesaas, 'store')
        if (store && productId == b1g1ProductId) {
          const discounts = store.getters[`${cartx}cartDiscounts`]
          if (discounts) {
            const discount = find(discounts, d => get(d, 'payload.type') === 'coupon' &&
                get(d, 'payload.options.code') === b1g1Code)
            if (discount) {
              store.dispatch(`${cartx}removeCartDiscount`, discount)
            }
          }
        }

      }
    })

    EventBus.$on('cart.error.discounts.code', function ({error}, discount, vm) {
      const cartx = 'Shop/Orders/Cart/'
      vm.$nextTick(() => {
        const store = get(window.addiesaas, 'store')
        const items = values(store.getters[`${cartx}cartItems`] || {})
        const item = find(items,(i) => i.type === b1g1)
        const productId = get(item, 'payload.product_id')
        if (store && productId == b1g1ProductId) {
          store.dispatch("REUtils/cart/showCartInfo", {
            title: 'Error',
            headerText: 'You\'ve already received Buy 1 Get 1 Free offer.',
            footerText: 'Your Buy 1 Get 1 Free offer item have been removed from the cart.'
          })
          store.dispatch(`${cartx}removeCartItem`, item)
          EventBus.$emit('cart.validate')
        }
      })
    })

    // move header menu/icon etc. positioned over the modal below on modal view
    EventBus.$on('modal.beforeMount', function () {
      $('.swm-main-container.swm-site-content').css({'z-index': 2})
      $('.swm-all-header-wrapper').css({ 'cssText': 'z-index: 0 !important'})
      $('.swm-header-logo-section').css({'z-index': 2})
      $('#swm-wrap').css({'z-index': 9999})
    })

    // reset header menu/icon etc. position  modal hide
    EventBus.$on('modal.beforeDestroy', function () {
      $('.swm-main-container.swm-site-content').css({'z-index': ''})
      $('.swm-all-header-wrapper').css({ 'z-index': ''})
      // $('.swm-all-header-wrapper').css({ 'cssText': 'z-index: inherit'})
      $('.swm-header-logo-section').css({'z-index': ''}) // 3
      $('#swm-wrap').css({'z-index': ''}) // 999
    })

  }

  // Example DataFilter use
  if (DataFilter) {
    DataFilter.add('cart.summary.details', (details, costDetails, vm) => {
      //details.push({label: 'Discounts', key: 'price_discounts', value: -10})
    })
    DataFilter.add('profile.cards', (cards, vm) => {

    })
    DataFilter.add('profile.card', (card, vm) => {
      // card.maskedNumber = '**** ****'
    })
  }
}
if (window.VueEventBus && window.addiesaas) {
  listerers()
} else {
  ready(listerers)
}

